import { makeStyles } from '@material-ui/core/styles';

import { borderGreyColor, secondaryMono1 } from 'Styles/theme';

export const useStyles = makeStyles(theme => {
	return {
		fieldSection: {
			paddingTop: 20,
			paddingBottom: 20,
			width: '100%',
			borderBottom: `1px solid ${borderGreyColor}`,
			fontSize: 14
		},
		sampleSection: {
			width: '100%',
			fontSize: 14
		},
		productTypeField: {
			color: secondaryMono1,
			lineHeight: '18px',
			fontWeight: 500,
			fontSize: 14
		},
		productDecscriptionWrapper: {
			'& > :first-child': {
				marginTop: 20
			}
		},
		fieldContainer: {
			paddingBottom: 5
		},
		fieldValue: {
			fontWeight: 'bold'
		}
	};
});
